var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEntryOrExitNotAllowPopup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3638 21.9084L18.7273 46C18.7273 46 23.9545 46 23.9545 39.7152V28.1931H42.7724C43.5707 28.1975 44.3533 27.9716 45.0269 27.5425C45.7005 27.1134 46.2367 26.4991 46.5714 25.773C46.9061 25.047 47.0253 24.2397 46.9146 23.4477C46.804 22.6556 46.4683 21.9122 45.9474 21.3061C46.6333 20.9032 47.1893 20.3116 47.5495 19.6014C47.9097 18.8913 48.0589 18.0926 47.9794 17.3C47.9 16.5074 47.5951 15.7544 47.1011 15.1302C46.6071 14.5061 45.9448 14.0371 45.1926 13.779C45.5638 13.2298 45.799 12.5999 45.8787 11.9414C45.9584 11.2829 45.8803 10.6149 45.6508 9.99275C45.4214 9.37058 45.0472 8.81217 44.5594 8.36381C44.0715 7.91545 43.4841 7.59006 42.8456 7.41462C43.2993 6.9821 43.6131 6.42318 43.7463 5.8101C43.8796 5.19703 43.8263 4.558 43.5932 3.97561C43.3602 3.39323 42.9582 2.89427 42.4391 2.54325C41.92 2.19223 41.3078 2.00528 40.6816 2.00657H23.9545C19.2339 1.9049 14.5626 2.98498 10.3638 5.14896",
    stroke: "#EB116B",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27265 3.05371H4.09088C2.93612 3.05371 2 3.99164 2 5.14864V24.003C2 25.16 2.93612 26.0979 4.09088 26.0979H8.27265C9.42741 26.0979 10.3635 25.16 10.3635 24.003V5.14864C10.3635 3.99164 9.42741 3.05371 8.27265 3.05371Z",
    stroke: "#EB116B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEntryOrExitNotAllowPopup);
export default __webpack_public_path__ + "static/media/icon_entryOrExitNotAllowPopup.d080aed2.svg";
export { ForwardRef as ReactComponent };